import { render, staticRenderFns } from "./useBtn.vue?vue&type=template&id=1d30001a&scoped=true"
import script from "./useBtn.vue?vue&type=script&lang=js"
export * from "./useBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d30001a",
  null
  
)

export default component.exports